module.exports = {
    'property-link': require('./property-link'),
    'property-code': require('./property-code'),
    'customer-link': require('./customer-link'),
    'customer': require('./customer')
}



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/components/parsed/components.js